import { ValueGetterParams } from 'ag-grid-community';

const isSyntheticOrderRow = (data: any) =>
  Boolean(
    data?.isOrderPending ||
      (typeof data?.id === 'string' && data.id.startsWith('pending-')),
  );

const getFrequencyPlan = (
  data: any,
  rgHash: mumms.HashedRoleGroup,
): mumms.ProcessedCarePlan | null => {
  const { id, roleGroupId } = data || {};
  if (id == null || roleGroupId == null || isSyntheticOrderRow(data)) {
    return null;
  }
  return rgHash[roleGroupId.toString()]?.frequencies?.[id] || null;
};

// determines which role to display in the cell depending if a worker is assigned or idg team member assigned to RG.
export const getDisplayRole = (
  params: ValueGetterParams,
  rgHash: mumms.HashedRoleGroup,
): string | null => {
  const { id } = params.data;
  if (typeof id === 'number') {
    return null;
  }
  return getFrequencyPlan(params.data, rgHash)?.discipline ?? null;
};

// determines if a given row has master/detail content
export const getRoleGroupMaster = (
  data: any,
  rgHash: mumms.HashedRoleGroup,
): boolean => {
  const { id } = data;
  if (typeof id === 'number' || isSyntheticOrderRow(data)) return false;
  return Boolean(getFrequencyPlan(data, rgHash)?.nonCurrentRows?.length);
};

// supplied detail row data to grid.
export const getBaseDetailRow = (params: any) => {
  const { data } = params;
  const detailRows = data?.frequencies?.[0]?.nonCurrentRows;
  params.successCallback(Array.isArray(detailRows) ? detailRows : []);
};
